export default class Double {
  constructor(view, i) {
    this.view = view;
    this.text = `x${2 ** (i + 1)}`;
    this.reset();
  }

  reset() {
    this.view.frame.visible = false;
    this.view.bg.alpha = 0.1;
    this.view.txt.text = this.text;
  }

  play() {
    this.view.frame.visible = true;
    createjs.Tween.get(this.view.frame, { loop: true })
      .to({ alpha: 0.2 }, 500)
      .to({ alpha: 1 }, 500);
  }

  showWin(win) {
    if (!win) {
      this.view.frame.visible = false;
    }
    createjs.Tween.get(this.view.frame, { override: true })
      .to({ alpha: 1 });

    createjs.Tween.get(this.view.bg)
      .to({ alpha: 1 }, 600);

    createjs.Tween.get(this.view.txt)
      .to({ scaleX: 0.5, scaleY: 0.5, text: win }, 150)
      .to({ scaleX: 1.2, scaleY: 1.2 }, 300)
      .to({ scaleX: 1, scaleY: 1 }, 100);
  }
}



// WEBPACK FOOTER //
// ../base/js/display/Double.js